import React, { useEffect, useState } from 'react'
import CompanyFilter from './components/CompanyFilter';
import CompanyTable from './components/CompanyTable';
import useCompany from './useCompany';
import Loader from 'components/loader';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import EditCompany from './components/EditCompany';

function Companies() {

  const [companies, setCompanies] = useState([])
  const [companiesMeta, setCompaniesMeta] = useState(null)
  const [editCompanyDetails, setEditCompanyDetails] = React.useState(null);
  const [filters, setFilters] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const { fetchCompanies, deleteCompany, loading } = useCompany();

  const handleSnackbar = (newMessage, severity = "success") => {
    setSnackbar({ open: true, message: newMessage, severity });
  };

  const handleSnackbarClose = (event, reason) => {
    setSnackbar({ ...snackbar, open: false });
  };

  const filtersConfig = [
    {
      type: "text",
      name: "name",
      placeholder: "Search Company",
    },
  ];

  const getCompanies = async (params) => {
    const data = await fetchCompanies(params)
    setCompanies([...data.resources])
    setCompaniesMeta({ currentPage: data.page, totalCount: data.total, take: data.limit })
  }

  const handleDeleteCompany = async (companyId) => {
    const response = await deleteCompany(companyId);
    if (response) {
      handleSnackbar("Company deleted successfully!");
      getCompanies({ page: "1", limit: "10" });
    }
  };

  useEffect(() => {
    getCompanies({ page: "1", limit: "10" })
  }, [editCompanyDetails])

  return (
    loading ? <div className="h-screen w-full">
      <Loader size={16} />
    </div> : (

    
      <div className="mt-8">
        { <>
         
          <CompanyFilter
            filters={filters}
            setFilters={setFilters}
            filtersConfig={filtersConfig}
            onApplyFilters={(data) => { getCompanies({ search: data?.name, page: "1", limit: "10" }) }}
          />

          <div className="overflow-x-auto" style={{ maxWidth: "100%" }}>
            <table style={{ minWidth: "100%" }} className="w-full table-auto">
              <CompanyTable
                tableData={companies}
                handleItemsPerPageChange={(e) => { getCompanies({ skip: "0", take: e.target.value }) }}
                handlePageChange={(e, newPage) => { getCompanies({ skip: companiesMeta.take * (newPage - 1), take: companiesMeta.take }) }}
                currentPage={companiesMeta?.currentPage}
                totalCount={companiesMeta?.totalCount}
                itemsPerPage={companiesMeta?.take}
                setEditCompanyDetails={setEditCompanyDetails}
                handleDeleteCompany={handleDeleteCompany}
              />
            </table>
          </div>

        </>
        }
        <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled" sx={{ width: "100%" }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
        <EditCompany isOpen={editCompanyDetails} onClose={()=>{
          setEditCompanyDetails(null)
        }}
        companyData={editCompanyDetails}
        handleSnackbar={handleSnackbar}
        /> 
      </div>

  
    )
  )
}

export default Companies